import type { ReactNode } from 'react';
import type React from 'react';
import { RiDeleteBinLine } from '@itandi/itandi-bb-ui';
import Styles from './DeleteMenuButton.module.scss';
import { Button } from '~/components/common/parts/button/Button';

type Props = {
  children: ReactNode;
  onClick: () => void | Promise<void>;
};

export const DeleteMenuButton: React.FC<Props> = ({
  children,
  onClick
}: Props) => (
  <Button onClick={onClick} size="sm" variant="normal">
    <RiDeleteBinLine className={Styles.Icon} />
    {children}
  </Button>
);
